import { render } from "./searchModal.vue?vue&type=template&id=a17436b4&ts=true"
import script from "./searchModal.vue?vue&type=script&lang=ts"
export * from "./searchModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__